import quantityId from '../enums/quantityId.js';
import Quantity from '../entities/quantity.js';
import Unit from '../entities/unit.js';
import UnitNonLinear from '../entities/unitNonLinear.js';

const temperature = new Quantity(
    quantityId.TEMPERATURE,
    'Temperature'
);

temperature.registerUnit(
    new Unit(
        'K', 1, 'Kelvin', [
            'K'
        ]
    )
);

temperature.registerUnit(
    new UnitNonLinear(
        'C',
        (kelvins) => { return kelvins - 273.15; },
        (celsius) => { return celsius + 273.15; },
        'Celsius',
        ['°C']
    )
);

temperature.registerUnit(
    new UnitNonLinear(
        'F',
        (kelvins) => { return kelvins * 9/5 - 459.67; },
        (fahrenheit) => { return (fahrenheit + 459.67) * 5/9; },
        'Fahrenheit',
        ['°F']
    )
);

export default temperature;